<section id="advertising" class="d-flex flex-column justify-content-center">
    <div class="container-fluid">
        <div class="row ">
            <div class="col-lg-5 offset-2 col-8">
                <p class="text-justify font-weight-bold my-4 my-lg-0">
                    <span i18n>AL-ARBULI SDAD. COOP. ANDALUSIA has received aid from the European Union under the European Regional Development Fund for the </span>
                    <u i18n>Installation of Photovoltaic Self-Consumption</u> 
                    <span i18n> within the Programme for the sustainable energy development of Andalusia in the period 2017-2020, which aims to achieve a cleaner and more sustainable economy.</span>
                    <br>
                    <br>
                    <span i18n>To achieve a cleaner and more sustainable economy.</span>
                </p>
            </div>
            <div class="col-lg-3 offset-2 offset-lg-0 col-8">
                <div class="d-flex flex-column align-items-center">
                    <img class="my-4 my-lg-0" src="assets/advertising/adv2.svg">
                    <img class="my-4 my-lg-0" src="assets/advertising/adv1.svg">
                </div>
            </div>
            <div class="offset-2 col-lg-5 col-8 d-flex justify-content-lg-start justify-content-center">
                <img class="my-4 my-lg-0" src="assets/advertising/adv4.svg">
            </div>
            <div class="col-lg-3 d-flex justify-content-center">
                <img class="my-4" src="assets/advertising/adv3.svg">
            </div>
        </div>
    </div>
</section>